// extracted by mini-css-extract-plugin
export default {"active":"zCzMgzmxGtdHzUoetOsJ","Advertisement":"yzx287MoNV6Vbby0ra7s","ParentAdvertisement":"MrUI31ukAwQNQ5zr9Hsw","main":"gBoMeyWTOeoWosaA3HzM","mainFill":"htNPQTg1wYH4PCtFuE2C"};